import api from '@/services/api'

import Auth from '../auth/index'
import { apiErrorHandler } from '../utils/apiErrors'

const EVENT_ENDPOINT = 'events/'

export default class EventAPI {
  /**
   * Instantiate a new `EventAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `EventAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new EventAPI(cls)
  }

  /* Get the API Client. */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one event from the API.
   *
   * @param {String} eventId  Unique ID of the event to retrieve.
   */
  get(eventId) {
    const url = `${EVENT_ENDPOINT}${eventId}/`
    return this.client
      .get(url)
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Get Event API error' }))
  }

  /**
   * Get List of events via the API
   *
   * @returns {Promise} - Promise wrapping the API response data
   */
  async list({ filters = {} } = {}) {
    const authHeader = Auth.getAuthorizationHeader()
    const options = {
      headers: {
        ...authHeader,
      },
      params: {},
    }

    if (filters.page) {
      options.params.page = filters.page
    }

    return this.client
      .get(EVENT_ENDPOINT, options)
      .then(response => {
        return {
          ...response.data,
          results: response.data.results.map(this.cls.fromAPI),
        }
      })
      .catch(apiErrorHandler({ apiName: 'List Events API error' }))
  }

  /**
   * Async retrieve a single event from the API
   * @param {string} eventId - ID of the event to retrieve.
   * @returns {Promise} - Promise wrapping the retrieved `event` instance.
   */
  async retrieve(eventId) {
    const url = `${EVENT_ENDPOINT}${eventId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }
}
